import { useMemo } from "react";
import { useSelector } from "react-redux";
import { DocumentViewer } from "./DocumentViewer";
import { parseDocumentUrls } from "./utils";

type InvoiceData = {
  [key: string]: string | number | boolean | null | undefined | object;
};

type InvoiceDocumentViewerProps = {
  /** Dimmed toolbar while the user is working on the form side of the screen. */
  isPreviewActive?: boolean;
};

/**
 * Renders the files of the currently selected invoice. Kept separate from
 * DocumentViewer so that stays a plain, reusable presentational component.
 */
export const InvoiceDocumentViewer = ({
  isPreviewActive = true,
}: InvoiceDocumentViewerProps) => {
  const selectedInvoiceData: InvoiceData = useSelector(
    (state: { selectedInvoiceData: { selectedInvoiceData: InvoiceData } }) =>
      state.selectedInvoiceData.selectedInvoiceData
  );

  const documentUrl = selectedInvoiceData?.documentUrl?.toString() ?? "";
  const urls = useMemo(() => parseDocumentUrls(documentUrl), [documentUrl]);

  const fileName =
    (selectedInvoiceData?.fileName as string) ||
    (selectedInvoiceData?.originalFileName as string) ||
    undefined;

  return (
    <DocumentViewer
      urls={urls}
      fileName={urls.length > 1 ? undefined : fileName}
      isToolbarActive={isPreviewActive}
    />
  );
};
